module.exports = new __parcel__URL__("fire--dataset-cover.e879c7bf.jpg").toString();